import React from "react";

export default function Socials() {
  return (
    <div className="socials-container">
      <a
        rel="noreferrer"
        href="https://github.com/jonahjtr"
        target="_blank"
        className="github"
      >
        {" "}
      </a>{" "}
      <a
        rel="noreferrer"
        href="https://www.linkedin.com/in/jonah-tillman/"
        target="_blank"
        className="linked-in"
      >
        {" "}
      </a>
      <a href="https://www.twitter.com" alt="twitter" className="twitter">
        {" "}
      </a>
    </div>
  );
}
